import {
    BalconyTerraceIcon,
    EastIcon,
    FloorGroundIcon,
    FloorLowerIcon,
    FloorTopIcon,
    FloorUpperIcon,
    KitchenIcon,
    KitchenSeparateIcon,
    LeafIcon,
    NorthIcon,
    SouthIcon,
    WestIcon
} from "@pg-design/icons-module";

import {QuarterType} from "../../property/components/PropertyDetailGeneratedDescriptionFlat";
import {ConfiguratorCheckboxType} from "../types/ConfiguratorCheckboxType";
import {Floor} from "../types/Floor";
import {KitchenType} from "../types/KitchenType";
import {FormAdditionalAreaType} from "../types/RoomType";

export const additionalAreasCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Balkon lub taras",
        icon: BalconyTerraceIcon,
        name: "rooms_area_type_selected",
        value: FormAdditionalAreaType.BALCONY,
        narrow: isNarrow
    },
    {
        label: "Ogródek",
        icon: LeafIcon,
        name: "rooms_area_type_selected",
        value: FormAdditionalAreaType.GARDEN,
        narrow: isNarrow
    }
];

export const kitchenCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Aneks kuchenny",
        icon: KitchenIcon,
        name: "kitchen_type",
        value: KitchenType.KITCHENETTE,
        narrow: isNarrow
    },
    {
        label: "Oddzielna kuchnia",
        icon: KitchenSeparateIcon,
        name: "kitchen_type",
        value: KitchenType.CLOSED,
        narrow: isNarrow
    }
];

export const floorsCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Parter",
        icon: FloorGroundIcon,
        name: "floors",
        value: Floor.GROUND,
        narrow: isNarrow
    },
    {
        label: "Niskie piętro (1-4)",
        icon: FloorLowerIcon,
        name: "floors",
        value: Floor.LOWER,
        narrow: isNarrow
    },
    {
        label: "Wysokie piętro (5+)",
        icon: FloorUpperIcon,
        name: "floors",
        value: Floor.UPPER,
        narrow: isNarrow
    },
    {
        label: "Ostatnie piętro",
        icon: FloorTopIcon,
        name: "floors",
        value: Floor.TOP,
        narrow: isNarrow
    }
];

export const wordDirectionCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Północ",
        icon: NorthIcon,
        name: "world_directions",
        value: QuarterType.NORTH.toString(),
        narrow: isNarrow
    },
    {
        label: "Południe",
        icon: SouthIcon,
        name: "world_directions",
        value: QuarterType.SOUTH.toString(),
        narrow: isNarrow
    },
    {
        label: "Wschód",
        icon: EastIcon,
        name: "world_directions",
        value: QuarterType.EAST.toString(),
        narrow: isNarrow
    },
    {
        label: "Zachód",
        icon: WestIcon,
        name: "world_directions",
        value: QuarterType.WEST.toString(),
        narrow: isNarrow
    }
];
import {
    BalconyTerraceIcon,
    EastIcon,
    FloorGroundIcon,
    FloorLowerIcon,
    FloorTopIcon,
    FloorUpperIcon,
    KitchenIcon,
    KitchenSeparateIcon,
    LeafIcon,
    NorthIcon,
    SouthIcon,
    WestIcon
} from "@pg-design/icons-module";

import {QuarterType} from "../../property/components/PropertyDetailGeneratedDescriptionFlat";
import {ConfiguratorCheckboxType} from "../types/ConfiguratorCheckboxType";
import {Floor} from "../types/Floor";
import {KitchenType} from "../types/KitchenType";
import {FormAdditionalAreaType} from "../types/RoomType";

export const additionalAreasCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Balkon lub taras",
        icon: BalconyTerraceIcon,
        name: "rooms_area_type_selected",
        value: FormAdditionalAreaType.BALCONY,
        narrow: isNarrow
    },
    {
        label: "Ogródek",
        icon: LeafIcon,
        name: "rooms_area_type_selected",
        value: FormAdditionalAreaType.GARDEN,
        narrow: isNarrow
    }
];

export const kitchenCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Aneks kuchenny",
        icon: KitchenIcon,
        name: "kitchen_type",
        value: KitchenType.KITCHENETTE,
        narrow: isNarrow
    },
    {
        label: "Oddzielna kuchnia",
        icon: KitchenSeparateIcon,
        name: "kitchen_type",
        value: KitchenType.CLOSED,
        narrow: isNarrow
    }
];

export const floorsCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Parter",
        icon: FloorGroundIcon,
        name: "floors",
        value: Floor.GROUND,
        narrow: isNarrow
    },
    {
        label: "Niskie piętro (1-4)",
        icon: FloorLowerIcon,
        name: "floors",
        value: Floor.LOWER,
        narrow: isNarrow
    },
    {
        label: "Wysokie piętro (5+)",
        icon: FloorUpperIcon,
        name: "floors",
        value: Floor.UPPER,
        narrow: isNarrow
    },
    {
        label: "Ostatnie piętro",
        icon: FloorTopIcon,
        name: "floors",
        value: Floor.TOP,
        narrow: isNarrow
    }
];

export const wordDirectionCheckboxes = (isNarrow?: boolean): ConfiguratorCheckboxType[] => [
    {
        label: "Północ",
        icon: NorthIcon,
        name: "world_directions",
        value: QuarterType.NORTH.toString(),
        narrow: isNarrow
    },
    {
        label: "Południe",
        icon: SouthIcon,
        name: "world_directions",
        value: QuarterType.SOUTH.toString(),
        narrow: isNarrow
    },
    {
        label: "Wschód",
        icon: EastIcon,
        name: "world_directions",
        value: QuarterType.EAST.toString(),
        narrow: isNarrow
    },
    {
        label: "Zachód",
        icon: WestIcon,
        name: "world_directions",
        value: QuarterType.WEST.toString(),
        narrow: isNarrow
    }
];
